import { RobotoFont } from '../../../styles/fonts';
import styledComp from '@emotion/styled';
import { Button, styled } from '@mui/material';
import Image from 'next/image';

export const StyledPriceBlock = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  '@media only screen and (max-width: 821px)': {},
  '@media only screen and (max-width: 768px)': {},
}));

export const StyledInfo = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  marginBottom: '32px',
  '@media only screen and (max-width: 768px)': {
    marginBottom: '38px',
    padding: '0 10px',
  },
}));

export const StyledFavorite = styled('span')(() => ({
  position: 'absolute',
  right: '5px',
  top: '16px',
  '@media only screen and (max-width: 768px)': {
    top: '2px',
    right: '0px',
  },
}));

export const StyledCompare = styled('span')(() => ({
  cursor: 'pointer',
  position: 'absolute',
  right: '5px',
  top: '45px',
  '@media only screen and (max-width: 768px)': {
    top: '30px',
    right: '0px',
  },
}));

export const StyledButtonIconBlock = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
  gap: '119px',
  marginBottom: '16px',
  '@media only screen and (max-width: 767px)': {
    padding: '0 10px',
    marginBottom: '12px',
    gap: '16px',
  },
}));

export const StyledButtons = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '11px',
  width: '100%',
  '@media only screen and (max-width: 768px)': {
    maxWidth: '100%',
    gap: '7px',
  },
}));

export const StyledButton = styled(Button)(() => ({
  '@media only screen and (max-width: 768px)': {
    fontSize: '16px !important',
  },
  '&:hover': {
    background: 'white !important',
    color: '#181818 !important',
  },
}));

export const StyledProductLink = styled('div')(() => ({
  marginBottom: '24px',
  fontFamily: `${RobotoFont.style.fontFamily}, sans-serif`,
  fontStyle: 'normal',
  fontWeight: 300,
  fontSize: '16px',
  lineHeight: '20px',
  textTransform: 'capitalize',
  color: '#000000',
  '@media only screen and (max-width: 768px)': {
    fontSize: '14px',
    padding: '0 5px',
  },
}));

export const StyledLink = styled('a')(() => ({
  fontFamily: `${RobotoFont.style.fontFamily}, sans-serif`,
  fontSize: '16px',
  lineHeight: '20px',
  fontWeight: 300,
  color: 'rgba(38, 63, 149, 1)',
  '@media only screen and (max-width: 768px)': {
    fontSize: '14px',
  },
  '&:hover': {
    textDecoration: 'underline',
  },
}));

export const StyledAdditionally = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  borderBottom: '1px solid #808080',
  '@media only screen and (max-width: 767px)': {
    marginRight: 0,
    paddingTop: '3px',
    paddingBottom: '16px',
  },
}));

export const StyledTrustedSellerBlock = styled('div')(() => ({
  borderTop: '1px solid #808080',
  paddingTop: '24px',
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
  gap: '119px',
  marginBottom: '16px',
  '@media only screen and (max-width: 767px)': {
    padding: '16px 10px 0',
    marginBottom: '12px',
    gap: '16px',
  },
  '@media only screen and (min-width: 1024px)': {
    gap: 0,
    justifyContent: 'space-between',
  },
}));

export const StyledList = styled('ul')(() => ({
  margin: 0,
  paddingInlineStart: '20px',
}));

export const StyledListItem = styled('li')(() => ({
  listStyleType: 'disc !important',
  marginBottom: '8px !important',
  '@media only screen and (max-width: 768px)': {
    marginBottom: '7px !important',
  },
  '@media only screen and (min-width: 1024px)': {
    textAlign: 'left',
  },
}));

export const StyledDivBtnIcon = styled('div')(() => ({
  '@media only screen and (min-width: 1024px)': {
    marginRight: '37px',
  },
  '@media only screen and (max-width: 767px)': {
    display: 'none',
  },
}));

export const StyledBtnIcon = styled(Image)(() => ({
  position: 'relative',
  gap: '10px',
  '@media only screen and (min-width: 1024px)': {
    height: '100%',
    width: 'auto!important',
  },
  '@media only screen and (max-width: 767px)': {
    position: 'relative',
  },
}));

export const StyledDivBtnAdditionally = styled('div')(() => ({
  display: 'none',
  '@media only screen and (max-width: 767px)': {
    display: 'flex',
  },
}));

export const modalStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: '2px',
  outline: 'none',
  width: 419,
  '@media screen and (max-width: 600px)': {
    width: 350,
  },
};

export const ModalContainer = styledComp.div`
  width: 100%;
  position: relative;
  height: auto;

  .content-wrapper {
    width: 100%;
    padding: 24px 0 0 0;
    max-height: 85vh;
    overflow-y: auto;

    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    ::-webkit-scrollbar-track {
      border-radius: 5px;
      background-color: #ffffff;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: #ffffff;
    }
  }

  .close-icon {
    height: 16px;
    position: absolute;
    top: 48px;
    right: 60px;
  }

  .close-icon:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 600px) {
    padding: 24px 12px;
  }
`;
